<template>
  <div class="design-data">
    <span class="pb-2">
      <b>Status:</b> {{ design.status }}
      <span v-if="statusAge" class="has-text-grey" :title="design.status_at">({{ statusAge }})</span>
    </span>

    <p v-if="!productGroups.length" class="has-text-grey">Geen producten in het ontwerp</p>
    <div v-for="group in productGroups" :key="group.type" class="pb-2">
      <p class="product-type">{{ group.label }}</p>
      <p v-for="(product, i) in group.products" :key="`${product.code}-${i}`" class="product">
        {{ product.amount }} x {{ product.description || product.code }}
      </p>
    </div>

    <details v-if="extraFields.length" class="mt-2">
      <summary class="has-text-grey is-clickable">Overige velden ({{ extraFields.length }})</summary>
      <span v-for="[key, value] in extraFields" :key="key" class="is-block">
        <b>{{ key.replace(/_/g, ' ') }}:</b> {{ value }}
      </span>
    </details>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { formatRelativeNl } from '@/util/DateTime'
import { groupProductsByType } from '@/util/productTypes'

interface DesignProduct {
  type: string
  code: string
  amount: number
  description?: string
}

@Component({})
export default class CallCentreDesignData extends Vue {
  @Prop({}) client!: { tasks: { design: any } }

  get design() {
    return this.client.tasks.design
  }

  get statusAge() {
    return formatRelativeNl(this.design.status_at)
  }

  get productGroups() {
    return groupProductsByType<DesignProduct>(this.design.products || [])
  }

  get extraFields() {
    return Object.entries(this.design.extra_fields || {})
  }
}
</script>

<style lang="scss" scoped>
.design-data {
  display: flex;
  flex-direction: column;

  .product-type {
    font-size: 0.75em;
    font-weight: bold;
    text-transform: uppercase;
    color: #7a7a7a;
    letter-spacing: 0.03em;
  }

  .product {
    font-size: 1.2em;
  }

  b {
    padding-right: 0.3rem;
    text-transform: capitalize;
  }
}
</style>
